export default __webpack_public_path__ + "static/media/ep6TN3.1291621f.jpg";